import { client } from '../http';

export default {
  async getInviteDetails() {
    const response = await client.get('/api/invite-auth/invite-details/');
    return response.data;
  },
};
